<template>
  <div>
    <SiteHero
      pageTitle="Wrestling"
      pageDescription="Learn Wrestling"
    />
    
    <div class="page-content">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div class="space-y-12">
          <ProgramDescription 
            :name="programData.name"
            :description="programData.description"
          />

          <ProgramBenefits :bulletPoints="programData.bulletPoints" />

          <ProgramCTA />
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '../Footer/SiteFooter.vue';
import SiteHero from '../Hero/SiteHero.vue';
import ProgramCTA from './ProgramCTA.vue';
import ProgramBenefits from './ProgramBenefits.vue';
import ProgramDescription from './ProgramDescription.vue';
import programsData from '@/data/programs.json';
import '../../assets/styles/page.css';

export default {
  name: 'WrestlingPage',
  components: {
    SiteFooter,
    SiteHero,
    ProgramCTA,
    ProgramBenefits,
    ProgramDescription
  },
  computed: {
    programData() {
      return programsData.programs.find(program => program.key === "wrestling");
    }
  }
};
</script> 